import { ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { Link } from "react-router-dom";

interface CustomInputProperties {
    label: string;
    link: string;
    icon?: React.ReactNode;
    onClick: () => void;
    isActive?: boolean;
  }

  export function SideMenuLink(properties: CustomInputProperties) {
    return (
        <Link
          to={properties.link}
          style={{ textDecorationColor: "transparent" }}
        >
          <ListItemButton
            onClick={() => {
                properties.onClick();
            }}
            sx={{
              backgroundColor: properties.isActive ? "rgba(255, 228, 181, 0.1)" : "transparent",
              "&:hover": {
                backgroundColor: properties.isActive 
                  ? "rgba(255, 228, 181, 0.2)" 
                  : "rgba(255, 255, 255, 0.1)",
              },
            }}
          >
            <ListItemIcon>
                {properties.icon}
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography 
                  variant="menulink" 
                  sx={{
                    textOverflow: "ellipsis",
                    WebkitLineClamp: 1,
                    lineClamp: 1,
                    overflow: "hidden",
                    wordBreak: "break-all",
                    WebkitBoxOrient: "vertical",
                    display: "-webkit-box",
                    color: properties.isActive ? "#FFE4B5" : "#FFFFFF",
                    fontWeight: properties.isActive ? 600 : 400,
                }}
                >
                  {properties.label}
                </Typography>
              }
            />
          </ListItemButton>
        </Link>
    );
  }